<template>
  <v-container fluid class="px-1 py-0">
    <gat-form :isLoading="isLoading">
      <div
        v-if="
          proformaStore.proformaWindow?.proformaInfo &&
          proformaStore.proformaWindow?.proformaLines &&
          proformaStore.proformaWindow?.currencies
        ">
        <v-container fluid class="mx-0 px-0">
          <v-row>
            <v-col cols="12" sm="12" lg="8" xl="10">
              <gat-group class="mb-4" title="Proforma" :collapsed="true" :compact="true" :collapsable="false">
                <template #compact>
                  <v-layout wrap>
                    <gat-compact-field
                      :value="/* vessel.VESSEL_PREFIX + ' '  */ proformaStore.proformaWindow.proformaInfo.VESSEL_NAME"
                      :link-url="'/vessel/' + proformaStore.proformaWindow.proformaInfo.VESSEL_ID"
                      label="Vessel name"
                      size="xs12 sm6 lg2" />
                    <gat-compact-field
                      size="s"
                      label="ETA"
                      :value="
                        globalFormatDateTime(proformaStore.proformaWindow.proformaInfo.ETA, 'DD.MMM.YYYY HH:mm')
                      " />
                    <gat-compact-field
                      size="s"
                      label="ETD"
                      :value="
                        globalFormatDateTime(proformaStore.proformaWindow.proformaInfo.ETD, 'DD.MMM.YYYY HH:mm')
                      " />
                    <gat-compact-field
                      size="s"
                      label="Proforma Number"
                      :value="proformaStore.proformaWindow.proformaInfo.PROFORMA_NUMBER" />
                    <gat-compact-field
                      size="s"
                      label="Agency"
                      :value="`${proformaStore.proformaWindow.proformaInfo.agency?.NAME ?? '-'}`" />
                    <gat-compact-field
                      size="s"
                      label="Currency"
                      :value="`${proformaStore.proformaWindow.proformaInfo.LOCAL_CURRENCY}`" />
                  </v-layout>
                </template>
                <v-layout wrap>
                  <gat-compact-field
                    :value="/* vessel.VESSEL_PREFIX + ' '  */ proformaStore.proformaWindow.proformaInfo.VESSEL_NAME"
                    :link-url="'/vessel/' + proformaStore.proformaWindow.proformaInfo.VESSEL_ID"
                    label="Vessel name"
                    size="xs12 sm6 lg2" />
                  <gat-vessel-select
                    v-if="false"
                    v-model="proformaStore.proformaWindow?.proformaInfo.VESSEL_ID"
                    label="Vessel"
                    size="xs12 sm6 lg2"
                    disabled />
                  <GatEdit
                    label="ETA"
                    v-model="proformaStore.proformaWindow.proformaInfo.ETA"
                    dateTimeEdit
                    futureDate
                    hint="Estimated time of arrival"
                    size="xs12 sm6 lg2"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <GatEdit
                    label="ETD"
                    v-model="proformaStore.proformaWindow.proformaInfo.ETD"
                    dateTimeEdit
                    futureDate
                    hint="Estimated time of departure"
                    size="xs12 sm6 lg2"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-compact-field
                    size="xs12 sm6 lg1"
                    label="Proforma Number"
                    :value="proformaStore.proformaWindow.proformaInfo.PROFORMA_NUMBER" />
                  <gat-compact-field
                    size="xs12 sm6 lg1"
                    label="Agency"
                    :value="`${proformaStore.proformaWindow.proformaInfo.agency?.NAME ?? '-'}`" />
                  <gat-compact-field
                    size="xs12 sm6 lg1"
                    label="Currency"
                    :value="`${proformaStore.proformaWindow.proformaInfo.LOCAL_CURRENCY}`" />
                </v-layout>
              </gat-group>

              <gat-group title="Criterias for calculation" :collapsed="true" :compact="true" :collapsable="false">
                <template #compact>
                  <v-layout wrap>
                    <gat-compact-field
                      size="xs4 sm3 md2 lg2 xl1"
                      label="Harbour"
                      :value="proformaStore.proformaWindow.proformaInfo.harbour?.NAME" />
                    <gat-compact-field
                      size="xs4 sm3 md2 lg2 xl1"
                      label="Terminal"
                      :value="proformaStore.proformaWindow.proformaInfo.quay?.TERMINAL_NAME" />
                    <gat-compact-field
                      size="xs4 sm3 md2 lg2 xl1"
                      label="Quay"
                      :value="proformaStore.proformaWindow.proformaInfo.quay?.NAME" />
                    <gat-compact-field
                      size="xs4 sm3 md2 lg2 xl1"
                      label="Vessel Type"
                      :value="
                        proformaStore.proformaWindow.proformaInfo.vesselType?.COMMENTS ??
                        proformaStore.proformaWindow.proformaInfo?.VESSEL_TYPE
                      " />
                    <gat-compact-field
                      size="xs8 sm3 md2 lg3 xl1"
                      label="Client"
                      :value="proformaStore.proformaWindow.proformaInfo.client?.NAME" />
                    <gat-compact-field size="s" label="GT" :value="proformaStore.proformaWindow.proformaInfo.GT" />
                    <gat-compact-field size="s" label="NT" :value="proformaStore.proformaWindow.proformaInfo.NT" />
                    <gat-compact-field size="s" label="DWT" :value="proformaStore.proformaWindow.proformaInfo.DWT" />
                    <gat-compact-field size="s" label="LOA" :value="proformaStore.proformaWindow.proformaInfo.LOA" />
                    <gat-compact-field size="s" label="BEAM" :value="proformaStore.proformaWindow.proformaInfo.BEAM" />
                    <gat-compact-field
                      size="s"
                      label="Loaded Qty"
                      :value="proformaStore.proformaWindow.proformaInfo.LOADED_Q" />
                    <gat-compact-field
                      size="s"
                      label="Discharged Qty"
                      :value="proformaStore.proformaWindow.proformaInfo.DISCH_Q" />
                    <gat-compact-field
                      size="s"
                      label="Draft"
                      :value="proformaStore.proformaWindow.proformaInfo.SUMMERDRAFT" />
                    <gat-compact-field
                      size="s"
                      label="Draft Departure"
                      :value="proformaStore.proformaWindow.proformaInfo.DRAFT_DEPARTURE" />
                    <gat-compact-field
                      size="s"
                      label="Draft Arrival"
                      :value="proformaStore.proformaWindow.proformaInfo.DRAFT_ARRIVAL" />
                    <gat-compact-field size="s" label="CSI" :value="proformaStore.proformaWindow.proformaInfo.CSI" />
                    <gat-compact-field size="s" label="ESI" :value="proformaStore.proformaWindow.proformaInfo.ESI" />
                    <gat-compact-field
                      size="s"
                      label="Pax Cap"
                      :value="proformaStore.proformaWindow.proformaInfo.PAX_CAP" />
                    <gat-compact-field size="s" label="SBT" :value="proformaStore.proformaWindow.proformaInfo.SBT" />
                    <gat-compact-field size="s" label="CBM" :value="proformaStore.proformaWindow.proformaInfo.CBM" />
                  </v-layout>
                </template>
                <v-layout wrap>
                  <!-- <GatHarbourSelect
            v-model="proformaWindow?.proformaInfo.HARBOUR_ID"
            label="Harbour"
            size="xs12 sm4 lg2"
            :readonly="!userCanEdit" /> -->
                  <QuaySelect
                    style="display: contents"
                    v-model="proformaStore.proformaWindow?.proformaInfo.QUAY_ID"
                    :harbour-select-props="{
                      label: 'Harbour',
                      size: 'xs12 sm4 lg2',
                    }"
                    :terminal-select-props="{
                      label: 'Terminal',
                      size: 'xs12 sm4 lg2',
                    }"
                    :quay-select-props="{
                      label: 'Quay',
                      size: 'xs12 sm4 lg2',
                    }"
                    size="xs12 sm4 lg2"
                    :readonly="!userCanEditProformaCalculationCriterias"
                    @harbour-changed="onHarbourChanged" />

                  <!-- :required="applicationStore.globalSettings.SGL_VESSEL_MAN_VESSELTYPE == 1" -->
                  <gat-select
                    v-model="proformaStore.proformaWindow?.proformaInfo.VESSEL_TYPE"
                    label="Vessel type"
                    size="xs12 sm6 md6 lg2"
                    :items="helperStore.vesselTypes"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-client-select
                    label="Client"
                    size="xs12 sm6 md6 lg3"
                    v-model="proformaStore.proformaWindow.proformaInfo.CLIENT_ID"
                    showClientWarning
                    showClientCreditLimit
                    :callId="callId"
                    :readonly="!userCanEditProformaCalculationCriterias"
                    :clearable="userCanEditProformaCalculationCriterias" />
                </v-layout>
                <v-layout wrap>
                  <!-- <gat-edit size="s" label="Client" v-model="proformaWindow.proformaInfo.client?.NAME" readonly /> -->
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="GT"
                    v-model="proformaStore.proformaWindow.proformaInfo.GT"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="NT"
                    v-model="proformaStore.proformaWindow.proformaInfo.NT"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="DWT"
                    v-model="proformaStore.proformaWindow.proformaInfo.DWT"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="LOA"
                    v-model="proformaStore.proformaWindow.proformaInfo.LOA"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="BEAM"
                    v-model="proformaStore.proformaWindow.proformaInfo.BEAM"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="Loaded Qty"
                    v-model="proformaStore.proformaWindow.proformaInfo.LOADED_Q"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="Discharged Qty"
                    v-model="proformaStore.proformaWindow.proformaInfo.DISCH_Q"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="Draft"
                    v-model="proformaStore.proformaWindow.proformaInfo.SUMMERDRAFT"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="Draft Departure"
                    v-model="proformaStore.proformaWindow.proformaInfo.DRAFT_DEPARTURE"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="Draft Arrival"
                    v-model="proformaStore.proformaWindow.proformaInfo.DRAFT_ARRIVAL"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="CSI"
                    v-model="proformaStore.proformaWindow.proformaInfo.CSI"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="ESI"
                    v-model="proformaStore.proformaWindow.proformaInfo.ESI"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="Pax Cap"
                    v-model="proformaStore.proformaWindow.proformaInfo.PAX_CAP"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="SBT"
                    v-model="proformaStore.proformaWindow.proformaInfo.SBT"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                  <gat-edit
                    size="s"
                    data-type="number"
                    label="CBM"
                    v-model="proformaStore.proformaWindow.proformaInfo.CBM"
                    :readonly="!userCanEditProformaCalculationCriterias" />
                </v-layout>
              </gat-group>
            </v-col>
            <v-col cols="12" sm="6" lg="4" xl="2">
              <v-card class="px-4 pb-6 d-flex flex-column" style="height: 100%">
                <v-card-title class="mb-1 px-0 pt-2 cardTitle text-body-2"
                  >Summary - {{ proformaStore.proformaWindow.proformaInfo.LOCAL_CURRENCY }}</v-card-title
                >
                <div class="d-flex flex-column flex-grow-1 mt-auto" style="font-size: 15px">
                  <div class="d-flex flex-grow-1 flex-row align-center justify-space-between">
                    <span> Amount </span>
                    <div>
                      {{
                        numeral(
                          getSubtotalInLocalCurrency(
                            proformaStore.proformaWindow.proformaLines,
                            proformaStore.proformaWindow.proformaInfo.LOCAL_CURRENCY,
                            proformaStore.proformaWindow.currencies
                          )
                        ).format('0,0.00')
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-grow-1 flex-row align-center justify-space-between">
                    <span> Rebate/Surcharge </span>
                    <div>
                      {{
                        numeral(
                          getTotalRebateInLocalCurrency(
                            proformaStore.proformaWindow.proformaLines,
                            proformaStore.proformaWindow.proformaInfo.LOCAL_CURRENCY,
                            proformaStore.proformaWindow.currencies
                          )
                        ).format('0,0.00')
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-grow-1 flex-row align-center justify-space-between">
                    <span> VAT </span>
                    <div>
                      {{
                        numeral(
                          getTotalVatInLocalCurrency(
                            proformaStore.proformaWindow.proformaLines,
                            proformaStore.proformaWindow.proformaInfo.LOCAL_CURRENCY,
                            proformaStore.proformaWindow.currencies
                          )
                        ).format('0,0.00')
                      }}
                    </div>
                    <!-- <gat-edit
                    :value="
                      getTotalVatInLocalCurrency(
                        proformaWindow.proformaLines,
                        proformaWindow.proformaInfo.LOCAL_CURRENCY,
                        proformaWindow.currencies
                      )
                    "
                    hide-details
                    readonly
                    :decimals="2"
                    size="xs6"
                    :reverse="true"
                    data-type="number" /> -->
                  </div>
                  <v-divider />
                  <div class="d-flex flex-grow-1 flex-row align-center justify-space-between font-weight-black">
                    <span class=""> Sum </span>
                    <div class="">
                      {{
                        numeral(
                          getProformaTotalAmountInLocalCurrency(proformaStore.proformaWindow.proformaLines)
                        ).format('0,0.00')
                      }}
                    </div>
                    <!-- <gat-edit
                    :value="getProformaTotalAmountInLocalCurrency(proformaWindow.proformaLines)"
                    hide-details
                    readonly
                    :decimals="2"
                    size="xs6"
                    :reverse="true"
                    data-type="number" /> -->
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-card class="px-2 mx-0 mt-4 grpClosed">
          <v-card-title class="text-body-2 mb-1 pa-0 pt-2 cardTitle">Lines</v-card-title>
          <ProformaLinesEdit
            :lines="proformaStore.proformaWindow.proformaLines"
            :currency="proformaStore.proformaWindow.currencies"
            :proforma-info="proformaStore.proformaWindow.proformaInfo"
            :readOnly="!userCanEdit"
            :LOCAL_CURRENCY="proformaStore.proformaWindow.proformaInfo.LOCAL_CURRENCY"
            @line-updated="onLineUpdated($event)" />
        </v-card>
        <v-container fluid class="mb-12 mx-0 px-0">
          <v-row>
            <v-col cols="12" md="6" lg="8">
              <gat-group style="height: 100%" title="Details" :collapsed="true" :collapsable="true">
                <template #compact>
                  <v-layout wrap>
                    <gat-compact-field
                      v-if="proformaStore.proformaWindow.proformaInfo.COMMENTS_NEW"
                      size="xs12"
                      label="Comments"
                      :value="proformaStore.proformaWindow.proformaInfo.COMMENTS_NEW"
                      :hide="false" />
                    <gat-compact-field
                      v-if="proformaStore.proformaWindow.proformaInfo.DESCRIPTION"
                      size="xs12"
                      :hide="false"
                      label="Details"
                      :value="proformaStore.proformaWindow.proformaInfo.DESCRIPTION" />
                    <div
                      class="px-3"
                      v-if="
                        !proformaStore.proformaWindow.proformaInfo.DESCRIPTION &&
                        !proformaStore.proformaWindow.proformaInfo.COMMENTS_NEW
                      ">
                      No Details.
                    </div>
                  </v-layout>
                </template>
                <v-layout wrap>
                  <gat-edit
                    label="Comments"
                    size="xs12"
                    :rows="4"
                    :maxChars="applicationStore.getColumnLength('Proforma_Detail.COMMENTS')"
                    v-model="proformaStore.proformaWindow.proformaInfo.COMMENTS_NEW"
                    :readonly="!userCanEdit" />
                  <gat-edit
                    label="Description"
                    size="xs12"
                    v-model="proformaStore.proformaWindow.proformaInfo.DESCRIPTION"
                    :rows="4"
                    :maxChars="applicationStore.getColumnLength('Proforma_Detail.DETAIL_TEXT')"
                    :readonly="!userCanEdit" />
                </v-layout>
              </gat-group>
            </v-col>
            <v-col cols="12" md="6" lg="4">
              <!-- <gat-group title="Exchange Rate" :collapsable="false" :collapsed="true" :compact="true">
              <template #compact> -->

              <ProformaExchangeRateGrid
                :proforma-id="+props.proformaId"
                :currencies="proformaStore.proformaWindow.currencies"
                :user-can-edit="userCanEdit"
                :local-currency="proformaStore.proformaWindow.proformaInfo.LOCAL_CURRENCY"
                :proformaLines="proformaStore.proformaWindow.proformaLines"
                :proformaInfo="proformaStore.proformaWindow.proformaInfo"
                @update:proformaWindow="onUpdateProformaWindow" />

              <!-- </template>
            </gat-group> -->
            </v-col>
          </v-row>
        </v-container>
        <gat-bottom-panel
          v-if="userCanEdit"
          :orgValue="proformaStore.orgProformaWindow"
          :newValue="proformaStore.proformaWindow"
          :paramId="callId"
          itemDescription="proforma"
          :stopNavigate="true"
          :saveBtn="userCanEdit"
          :deleteBtn="false"
          :buttonsEnabled="!saving"
          @saveClicked="onSaveClicked">
        </gat-bottom-panel>
      </div>
    </gat-form>
  </v-container>
</template>

<script setup lang="ts">
import { computed, ref, watch, onMounted, onUnmounted, onDeactivated, onActivated } from 'vue';
import { GlobalHelperFunctions } from '@/common/GlobalHelperFunctions';
// eslint-disable-next-line import/no-cycle
import router from '@/router/router';
import { useToolbarStore } from '@/store/toolbarStore';
import { useApplicationStore } from '@/store/applicationStore';
import QuaySelect from '@/app-components/QuaySelect.vue';
import GatVesselSelect from '@/app-components/GatVesselSelect.vue';
import { useHelperStore } from '@/store/helperStore';
import GatClientSelect from '@/app-components/GatClientSelect.vue';
import numeral from 'numeral';
import type { ProformaLine, ProformaWindow } from '@/types/ProformaTypes';
import { GatResponseResultCategory } from '@/types/GatResponseResult';
import ProformaLinesEdit from './ProformaLinesEdit.vue';
import {
  getTotalVatInLocalCurrency,
  getTotalRebateInLocalCurrency,
  getSubtotalInLocalCurrency,
  getProformaTotalAmountInLocalCurrency,
  recalculateProforma,
} from '../utils/proforma-utils';
import ProformaExchangeRateGrid from './ProformaExchangeRateGrid.vue';
import { useProformaStore } from '../stores/proformaStore';

interface ProformaProps {
  callId: string;
  proformaId: number | string;
  location: 'portcall' | 'proforma';
}

const props = defineProps<ProformaProps>();
const toolbarStore = useToolbarStore();
const applicationStore = useApplicationStore();
const helperStore = useHelperStore();
const isLoading = ref(false);
const saving = ref(false);

const proformaStore = useProformaStore();

function onHarbourChanged(harbourId: number) {
  proformaStore.proformaWindow!.proformaInfo.HARBOUR_ID = harbourId;
}

function onUpdateProformaWindow(newProformaWindow: ProformaWindow) {
  proformaStore.proformaWindow = recalculateProforma(
    newProformaWindow.proformaLines,
    newProformaWindow.currencies,
    newProformaWindow.proformaInfo
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function onLineUpdated({ line, field }: { line: ProformaLine; field?: any }) {
  const proformaLines = [...proformaStore.proformaWindow!.proformaLines];
  const idx = proformaLines.findIndex((l) => l.ID === line.ID);
  if (typeof idx !== 'undefined' && idx >= 0) {
    // console.log(line, field);
    proformaLines.splice(idx, 1, line);
  }
  /* proformaWindow.value!.proformaLines = proformaLines; */
  const newProformaWindow = recalculateProforma(
    proformaLines,
    proformaStore.proformaWindow!.currencies,
    proformaStore.proformaWindow!.proformaInfo
  );
  proformaStore.proformaWindow = newProformaWindow;
}

async function onSaveClicked() {
  // Send the proforma to the backend
  try {
    const response = await proformaStore.updateProformaWindow(props.proformaId.toString(), {
      Value: proformaStore.proformaWindow!,
      OrgValue: proformaStore.orgProformaWindow!,
    });
    if (response.resultCategory === GatResponseResultCategory.Success) {
      router.back();
    }
  } finally {
    saving.value = false;
  }
}

const userCanEdit = computed(() => applicationStore.userRight('PR.EDIT'));

const userCanEditProformaCalculationCriterias = computed(
  () =>
    false /* This feature is not supported in the web module yet. When it is supported, you can remove this boolean and user userCanEdit instead. */
);

function globalFormatDateTime(date: any, format: any) {
  return GlobalHelperFunctions.globalFormatDateTime(date, format);
}

async function getProforma(proformaId: string) {
  isLoading.value = true;

  try {
    await proformaStore.fetchProformaWindow(proformaId);
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
}

function setBackNavigation() {
  const result = [];
  if (props.location === 'portcall' && props.callId) {
    result.push({ text: 'port call', href: `/call/${props.callId}` });
    result.push({ text: 'proforma list', href: `/call/${props.callId}/proforma` });
  }
  if (props.location === 'proforma' && props.proformaId) {
    result.push({ text: 'proforma', href: `/proforma/${props.proformaId}` });
    result.push({ text: 'proforma list', href: `/proforma` });
  }
  toolbarStore.setBackNavigation(result);
}

watch(
  () => props.proformaId,
  (newValue) => {
    if (newValue) {
      getProforma(newValue.toString());
    }
  },
  { immediate: true }
);

onMounted(() => {
  setBackNavigation();
});

onActivated(() => {
  setBackNavigation();
});

onUnmounted(() => {
  toolbarStore.setBackNavigation(undefined);
});

onDeactivated(() => {
  toolbarStore.setBackNavigation(undefined);
});
</script>

<style scoped lang="scss">
.grpClosed {
  margin-top: 1px;
  margin-bottom: 1px;
}
.cardTitle {
  color: var(--gatGroupCaption);
}
</style>
